import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TBCTXKeys, TBctxWithMultipleSizeAndCount } from '@monorepo/types';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  @Input() errorTxt = '';
  @Input() bctxItemsWithCount: TBctxWithMultipleSizeAndCount[] = [];
  @Input() bctxKeysToDisplayMap!: Record<TBCTXKeys, string>;
  errors: string[] = [];
  constructor(private modalCtrl: ModalController, private translate: TranslateService) {}

  ngOnInit(): void {
    this.errors = [];
    this.bctxItemsWithCount.forEach((bctxItemWithCount) => {
      const preSizeLevelErrorsString = bctxItemWithCount.preSizeLevelBctx
        .map((curr) => {
          return `${this.bctxKeysToDisplayMap[curr.k]}: ${curr.v}`;
        })
        .join(', ');
      bctxItemWithCount.sizes.forEach((sizeInfo) => {
        this.errors.push(
          `${this.translate.instant('input_app_error_modal.failedToRectify')} ${
            sizeInfo.count
          } ${this.translate.instant('input_app_error_modal.itemsOf')} ${
            preSizeLevelErrorsString + `, ${this.translate.instant('input_app_common.size')}: ${sizeInfo.name}`
          }`,
        );
      });
    });
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
